import { Link } from 'react-router-dom';
import { features } from '@/mocks/comics';

export default function FeatureGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 border border-background-300 rounded-full text-foreground-600 text-xs font-medium mb-4 whitespace-nowrap">
            平台特色
          </span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-3">
            为什么选择
            <span className="block">36漫画网？</span>
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            我们用心打造每一个阅读细节，只为给您最优质的韩国漫画阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 rounded-2xl bg-background-100 hover:bg-primary-50 transition-colors duration-300 cursor-default"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-background-200 mb-4 group-hover:bg-primary-100 transition-colors duration-300">
                <i className={`${feature.icon} text-xl text-foreground-700 group-hover:text-primary-600 transition-colors duration-300`}></i>
              </div>
              <h3 className="text-foreground-900 font-semibold text-base mb-2">{feature.title}</h3>
              <p className="text-foreground-500 text-sm leading-relaxed mb-4">{feature.description}</p>
              <Link
                to="/about"
                className="inline-flex items-center gap-1 text-sm text-foreground-400 group-hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                了解更多 <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}